module.exports = __webpack_public_path__ + "img/ball_cont_bad.4be60643.svg";